<template>
  <div>
    <v-dialog persistent v-model="showDialog" width="550" eager>
      <v-tabs-items v-model="tab" class="mt-0 pt-0">
        <!--Start: Step 1 - select plan-->
        <v-tab-item eager class="mt-0 pt-0">
          <v-card class="px-3">
            <v-card-title class="justify-space-between">
              You have used up your EventConnect credits
            </v-card-title>
            <v-card-subtitle>
              Continue making it easy for your attendees to connect seamlessly.
            </v-card-subtitle>
            <v-card-text>
              <v-alert
                dense
                outlined
                class="pa-0"
                :color="noOfCredits == plan.noOfCredits ? 'primary' : 'grey'"
                :text="noOfCredits == plan.noOfCredits ? true : false"
                v-for="plan in plans"
                :key="plan.index"
              >
                <v-list-item
                  two-line
                  class="py-0"
                  dense
                  @click="choosePlan(plan)"
                >
                  <v-list-item-content class="text-left py-0">
                    <v-list-item-title class="text-wrap">{{
                      plan.title
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-avatar class="my-0">
                    <div class="text-h5 primary--text font-weight-bold">
                      {{ plan.amount }}
                    </div>
                  </v-list-item-avatar>
                  <v-list-item-action class="my-0">
                    <v-chip
                      label
                      color="darken-3"
                      x-small
                      :style="{
                        visibility:
                          plan.noOfCredits != 12 ? 'hidden' : 'visible',
                      }"
                      >{{ plan.info }}</v-chip
                    >
                  </v-list-item-action>
                </v-list-item>
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-row>
                <v-col cols="12">
                  <v-btn color="primary" depressed block @click="tab = 1"
                    >Go to payment</v-btn
                  ></v-col
                >
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    text
                    depressed
                    block
                    @click="handleClick"
                    >Cancel</v-btn
                  ></v-col
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <!--End: Step 1 - select plan-->

        <!--Start: Step 2 - Payment details and make payment-->
        <v-tab-item :eager="true" class="mt-0 pt-0">
          <v-card class="px-3">
            <v-card-title class="justify-space-between">
              Payment details

              <div class="text-right">
                <v-btn fab text small @click="handleClick" right
                  ><v-icon>close</v-icon></v-btn
                >
              </div>
            </v-card-title>
            <v-card-text>
              <v-list-item two-line class="py-0 px-0" dense>
                <v-list-item-content class="text-left py-0">
                  <v-list-item-title class="text-wrap"
                    >{{ noOfCredits }} EventConnect
                    {{
                      noOfCredits == 1 ? "Credit" : "Credits"
                    }}</v-list-item-title
                  >
                  <v-list-item-subtitle
                    class="primary--text cursor-pointer"
                    @click="tab = 0"
                  >
                    Change this credit package
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action class="my-0">
                  <div class="text-body">${{ subTotalAmount }}</div>
                </v-list-item-action>
              </v-list-item>

              <v-divider v-if="gst > 0"></v-divider>
              <v-list-item v-if="gst > 0" class="py-0 px-0" dense>
                <v-list-item-content class="text-left py-0">
                  <v-list-item-title class="text-wrap">GST</v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="my-0">
                  <div class="text-body">${{ gst }}</div>
                </v-list-item-action>
              </v-list-item>

              <v-divider></v-divider>
              <div class="d-flex justify-end">
                <div class="py-3 text-body-1 font-weight-bold">
                  Total ${{ totalAmount }}
                </div>
              </div>
              <v-divider></v-divider>
              <v-list-item two-line class="py-0 mt-5 px-0" dense>
                <v-list-item-content class="text-left py-0">
                  <v-list-item-title class="text-wrap text-body-2"
                    >Payment Method</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <div>
                    <v-chip class="ma-1" label dark>
                      {{ businessProfile.paymentMethod.toUpperCase() }}
                    </v-chip>
                    <v-icon>more_horiz</v-icon>
                    <v-icon>more_horiz</v-icon>
                    <v-icon>more_horiz</v-icon>
                    <span class="text-subtitle-1 text--secondary">{{
                      businessProfile.lastFour
                    }}</span>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </v-card-text>
            <v-card-actions>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    depressed
                    block
                    @click="purchaseMCCredits"
                    >Pay ${{ totalAmount }}</v-btn
                  ></v-col
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <!--End: Step 2 - Payment details and make payment-->
      </v-tabs-items>
    </v-dialog>
    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Processing your payment...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" left multi-line :timeout="snackbarTimeout">
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbar = false"
          top
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import "firebase/functions";
import * as currency from "currency.js";
import {getHttpsCallable, updateBusinessProfilesDoc} from "@/shared/firebase_utils";
import { increment} from "firebase/firestore";

export default {
  props: {
    showDialog: { type: Boolean },
  },
  computed: {
    ...mapGetters(["businessProfile", "userProfile"]),
    subTotalAmount() {
      return currency(this.selectedPlanAmount);
    },
    gst() {
      if (this.businessProfile.country == "Australia")
        return currency(this.subTotalAmount).divide(10);
      else return currency(0);
    },
    totalAmount() {
      return currency(this.subTotalAmount).add(this.gst);
    },
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      snackbarTimeout: 5000,
      loadingDialog: false,
      plans: [
        {
          title: "1 MC credits",
          subtitle: "(valid for redemption within 3 months)",
          amount: 15,
          info: "0% off",
          noOfCredits: 1,
          index: 1,
        },
        {
          title: "6 MC credits",
          subtitle: "(valid for redemption within 12 months)",
          amount: 59,
          info: "12% off",
          noOfCredits: 6,
          index: 2,
        },
        {
          title: "12 MC credits",
          subtitle: "(valid for redemption within 12 months)",
          amount: 79,
          info: "Best Value",
          noOfCredits: 12,
          index: 3,
        },
      ],
      selectedPlan: {},
      noOfCredits: "12",
      selectedPlanAmount: 79,
      tab: 0,
    };
  },
  methods: {
    choosePlan(plan) {
      this.noOfCredits = plan.noOfCredits;
      this.selectedPlanAmount = plan.amount;
    },
    handleClick() {
      this.tab = 0;
      this.$emit("closeDialog");
    },
    purchaseMCCredits() {
      this.$emit("closeDialog");
      this.loadingDialog = true;
      const purchaseMCCredits = getHttpsCallable("purchaseMCCredits");
      console.log(
        "this.businessProfile.stripeCustomerId: ",
        this.businessProfile.stripeCustomerId
      );
      console.log("this.noOfCredits: ", this.noOfCredits);
      purchaseMCCredits({
        noOfCredits: this.noOfCredits,
        stripeCustomerId: this.businessProfile.stripeCustomerId,
        applyGST: this.gst > 0 ? true : false,
        businessProfileId: this.userProfile.businessProfileId,
      })
        .then(async (response) => {
          console.log("In purchaseMCCredits then");
          if (response.data.error != undefined) {
            console.log("Error while calling  purchaseMCCredits");
            console.log(response.data.error);
          } else {
            //Reuest sent successfully
            console.log("In the purchaseMCCredits else");
            console.log(response.data);
            if (response.data.isSuccess == true) {
              await
                updateBusinessProfilesDoc(this.userProfile.businessProfileId,{
                  multiConnectCredits: increment(
                    this.noOfCredits
                  ),
                });
              this.snackbarText = "Credits purchased successfully!";
              this.snackbarTimeout = 5000;
              this.snackbar = true;
            }
          }
          this.loadingDialog = false;
        })
        .catch((error) => {
          console.log("In purchaseMCCredits catch");
          console.log(error);
          this.loadingDialog = false;
        });
    },
  },
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
